import { useQuery } from '@tanstack/react-query';
import { pb } from '@/core/api';

export type RosterBucket = { active: number; total: number };

export type RosterCounts = {
  verifying: number;
  pre_collectors: RosterBucket;
  collectors: RosterBucket;
  registered: number;
};

type Analytics = {
  total: number;
  today: number;
  week: number;
  month: number;
  activeApproachers: number;
  roster: RosterCounts;
};

type OverviewResponse = {
  total: number;
  today: number;
  week: number;
  month: number;
  active_collectors: number;
  roster?: RosterCounts;
};

const EMPTY_ROSTER: RosterCounts = {
  verifying: 0,
  pre_collectors: { active: 0, total: 0 },
  collectors: { active: 0, total: 0 },
  registered: 0,
};

async function fetchOverview(): Promise<Analytics> {
  const r = await pb.send<OverviewResponse>('/api/progress/overview', {
    method: 'GET',
  });
  return {
    total: r.total,
    today: r.today,
    week: r.week,
    month: r.month,
    activeApproachers: r.active_collectors,
    roster: r.roster ?? EMPTY_ROSTER,
  };
}

export function useAnalytics() {
  return useQuery({
    queryKey: ['analytics'],
    queryFn: fetchOverview,
    staleTime: 60_000,
  });
}
